import { createBrowserRouter } from 'react-router-dom'

import { assessmentChildRoutes } from '@/modules/assessments/components/routes.tsx'
import App from '@/system/components/App.tsx'
import { ErrorHandler } from '@/system/components/ErrorHandler.tsx'

export const router = createBrowserRouter([
  {
    element: <App />,
    errorElement: <ErrorHandler />,
    children: [
      {
        path: '/',
        async lazy() {
          const { AssignmentList } = await import(
            '@/modules/assignments/components/AssignmentList.tsx'
          )
          return {
            Component: AssignmentList,
          }
        },
      },
      {
        path: '/assessment/:id',
        async lazy() {
          const { AssessmentComponent } = await import(
            '@/modules/assessments/components/Assessment.tsx'
          )
          return {
            Component: AssessmentComponent,
          }
        },
        children: assessmentChildRoutes,
      },
      {
        path: '/style-guide',
        async lazy() {
          const { StyleGuide } = await import(
            '@/modules/styleGuide/components/StyleGuide'
          )
          return {
            Component: StyleGuide,
          }
        },
      },
      {
        path: '*',
        element: <p>TODO: Add not found route?</p>,
      },
    ],
  },
])
